var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("Dependants")]),_c('AppFormTable',{attrs:{"fields":_vm.depColumns,"data":_vm.dependants,"errors":_vm.dependantsError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }